/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * UserInviteRevokedDtoBase
 * auto generated base class for the model UserInviteRevokedDtoModel.
 */
export const UserInviteRevokedDtoModelBase = ModelBase
  .named('UserInviteRevokedDto')
  .props({
    __typename: types.optional(types.literal("UserInviteRevokedDto"), "UserInviteRevokedDto"),
    /** UUID of the revoked user invite */
    inviteUuid: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserInviteRevokedDtoModelSelector extends QueryBuilder {
  get inviteUuid() { return this.__attr(`inviteUuid`) }
}
export function selectFromUserInviteRevokedDto() {
  return new UserInviteRevokedDtoModelSelector()
}

export const userInviteRevokedDtoModelPrimitives = selectFromUserInviteRevokedDto().inviteUuid
